export const composeErrorNotification = (message, description) => {
  return {
    type: "error",
    message,
    description,
    dateTime: Date.now(),
    duration: 4.5,
  };
};

export const composeInfoNotification = (message) => {
  return {
    type: "info",
    message,
    dateTime: Date.now(),
    duration: 4.7,
  };
};

export const composeSuccessNotification = (message) => {
  return {
    type: "success",
    message,

    dateTime: Date.now(),
    duration: 4,
  };
};

export const composeWarningNotification = (message, description) => {
  return {
    type: "warning",
    message,
    description,
    dateTime: Date.now(),
    duration: 4.5,
  };
};
